export const TableWidgets = {
    label: { name: 'Label'},
    input: { name: 'Input'},
    number: { name: 'Number'},
    datepicker: { name: 'Datepicker'},
    multicheckbox: { name: 'Checkbox'},
    radio: { name: 'Radio'}
  }